<template>
  <div>
    <a-form-model layout="inline">
      <a-form-model-item label="机构名称" v-if="!organizationId">
        <many-select
          v-model="searchForm.organizationId"
          showSearch
          allowClear
          optionFilterProp="name"
          :options="organizationList"
          :replaceFields="{ label: 'name', value: 'id' }"
          placeholder="请选择机构"
          class="search-item"
        >
        </many-select>
      </a-form-model-item>
      <a-form-model-item label="测评名称">
        <a-input placeholder="请输入测评名称" allow-clear :maxLength="20" class="search-item" v-model="searchForm.projectCourseConfigName" />
      </a-form-model-item>
      <a-form-model-item label="资源名称">
        <a-input placeholder="请输入资源名称" allow-clear :maxLength="20" class="search-item" v-model="searchForm.courseName" />
      </a-form-model-item>
      <a-form-model-item label="课时名称">
        <a-input placeholder="请输入课时名称" allow-clear :maxLength="20" class="search-item" v-model="searchForm.courseChildName" />
      </a-form-model-item>
      <a-form-model-item label="课时状态">
        <a-select v-model="searchForm.statuses" allowClear placeholder="请选择课时状态" class="search-item">
          <a-select-option value="0">未开始</a-select-option>
          <a-select-option value="1">进行中</a-select-option>
          <a-select-option value="2">已完成</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item>
        <a-button @click="getPageList(1)" type="primary">查询</a-button>
      </a-form-model-item>
    </a-form-model>
    <a-table
      :columns="courseColumns"
      :scroll="{ y: 300 }"
      style="min-width: 800px"
      :row-key="(item) => item.id + ',' + item.projectCourseConfigId + ',' + item.organizationId"
      :row-selection="rowSelection"
      :pagination="tableRelevant.tablePagination"
      :loading="tableRelevant.tableLoading"
      :locale="tableRelevant.locale"
      :dataSource="tableRelevant.tableDataSource"
    >
      <div slot="progress" slot-scope="text">
        <a-progress :percent="text.progress" size="small" />
      </div>
      <div slot="complateStatusName" slot-scope="text">
        <span v-if="text.progress === 0">未开始</span>
        <span v-else-if="text.progress === 100" style="color: #52c41a">已完成</span>
        <span v-else style="color: #1890ff">进行中</span>
      </div>
    </a-table>
  </div>
</template>

<script>
import { tableRelevant } from '@/pages/projectImpl/js/utils'
import ManySelect from '@/components/select/ManySelect'

const courseColumns = [
  // {title: '机构名称', dataIndex: 'organizationName'},
  { title: '测评名称', dataIndex: 'projectCourseConfigName' },
  { title: '资源名称', dataIndex: 'courseName' },
  { title: '课时名称', dataIndex: 'childCourseName' },
  { title: '学生数', dataIndex: 'studentCount' },
  { title: '课时进度', scopedSlots: { customRender: 'progress' } },
  { title: '状态', scopedSlots: { customRender: 'complateStatusName' } },
  { title: '创建时间', dataIndex: 'createTime' },
]
export default {
  name: 'StepsSecondAddCourse',
  components: { ManySelect },
  props: {
    organizationId: Number,
    selectData: {
      type: Array,
      default: [],
    },
    assessRoundItem: Object,
  },
  data() {
    return {
      courseColumns,
      organizationList: [],
      searchForm: {
        organizationId: undefined,
        projectCourseConfigName: undefined,
        courseName: undefined,
        courseChildName: undefined,
        statuses: undefined,
      },
      //表格相关
      tableRelevant: tableRelevant.call(this),
      //表格选中项
      selectedRowKeys: [],
      reportType: this.$store.getters['organization/getReportInfo'].reportType,
    }
  },
  computed: {
    rowSelection() {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: (selectedRowKeys) => {
          this.selectedRowKeys = selectedRowKeys
        },
        getCheckboxProps: (record) => ({
          props: {
            disabled: this.selectData.includes(record.id) || record.progress <= 0,
          },
        }),
      }
    },
  },
  mounted() {
    if (!this.organizationId) {
      if (this.courseColumns.length < 8) {
        this.courseColumns.unshift({ title: '机构名称', dataIndex: 'organizationName' })
      }
      this.getOrganizationList()
    } else {
      if (this.courseColumns.length > 7) {
        this.courseColumns.shift()
      }
    }
    this.getPageList(1)
  },
  methods: {
    //获取课时列表
    getPageList(pageIndex) {
      if (pageIndex) {
        this.tableRelevant.tablePagination.current = pageIndex
      }
      const params = {
        ...this.searchForm,
        isFiltration: true,
        pageIndex: this.tableRelevant.tablePagination.current,
        pageSize: this.tableRelevant.tablePagination.pageSize,
      }
      if (this.organizationId) {
        params.organizationId = this.organizationId
      }
      this.tableRelevant.tableLoading = true
      this.$http.GroupReport.getCourseChildList(params).then((res) => {
        this.tableRelevant.tableDataSource = res.data.items
        this.tableRelevant.tablePagination.total = res.data.totalCount
        this.tableRelevant.tablePagination.current = res.data.pageIndex
      }).finally(() => {
        this.tableRelevant.tableLoading = false
      })
    },
    // 获取机构列表
    getOrganizationList() {
      this.$http.loadAllByType({ isOnlySuperior: false, orgType: 1 }).then((res) => {
        this.organizationList = res.data.data
      })
    },
  },
}
</script>

<style scoped>
.search-item {
  width: 180px;
  margin-bottom: 15px;
}
</style>
